import { MovieOutlineIcon } from './MovieOutlineIcon';

/**
 * author: Google
 * id 8198AA61-F267-4A56-B9D8-5D492B519545
 * name movie-outline
 * version: 3.5.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/movie-outline.svg
 * tags
 * - Video / Movie 
 */
export const ClapperboardOutlineIcon = MovieOutlineIcon;
export default ClapperboardOutlineIcon